import JSEncrypt from 'jsencrypt';

import store from "../store/index";

export function encrypt(password) {
    let en = new JSEncrypt();
    en.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC4L/7MhR99+yswtvSr0dKenD/oJUaow2AEJ6OYn2n12Y4H9RIQY2W5Sr/h4iwMzQTpWFNT5y7jjpGY+qYNQOR1GS6bG2GuTMK9W1BwC41y2gd0xwqWV+df2+S9eHqxqOdib/4/+t2JYxLTJvAC5pGPEvt3z8RXmO8mvtlVzBLaZQIDAQAB");
    return en.encrypt(password)

}

export function specNameInit(goods, key) {
    try {
        if (is_Empty(goods)) return "";
        let obj_key = 'orderGoodsSpecificationInputBeans';
        if (!is_Empty(key)) {
            obj_key = key;
        }
        let spc_name = [];
        let excludeFields = ['定制', '小于', '大于']
        if (!is_Empty(goods.specification_name) && excludeFields.every(el => goods.specification_name.indexOf(el) === -1)) {
            spc_name.push(goods.specification_name)
        }
        let obj = {};
        goods[obj_key].forEach(el => {
            obj[el.input_name] = Number(el.input_value);
        })

        //如果spc_name数组不为空说明该商品为标准商品则直接拼接就行，不需要加*号。
        if (!spc_name.length) {
            if (obj.hasOwnProperty('goods_length')) {
                spc_name.push(`${obj.goods_length}m`)
            }
            if (obj.hasOwnProperty('goods_width')) {
                spc_name.push(`${obj.goods_width}m`)
            }
            if (obj.hasOwnProperty('weight')) {
                spc_name.push(`${obj.weight}${goods.price_unit}`)
            }
            return spc_name.join("*");
        } else {
            if (obj.hasOwnProperty('goods_length')) {
                spc_name.push(`长度:${obj.goods_length}m`)
            }
            if (obj.hasOwnProperty('goods_width')) {
                spc_name.push(`宽度:${obj.goods_width}m`)
            }
            if (obj.hasOwnProperty('weight')) {
                spc_name.push(`重量:${obj.weight}${goods.price_unit}`)
            }
            return spc_name.join(" ");
        }
    } catch (e) {
        return ""
    }
}

// 将商品俗称中的英文去除
function strNames(text) {
    if (is_Empty(text)) return "";
    let str = text, val = "";
    for (let i = 0; i < str.length; i++) {
        const el = str[i];
        if (/[\u4e00-\u9fa5]/.test(el)) {
            val += el;
        }

    }
    return val;
}

export function getValueByStringKey(obj, key) {
    const keys = key.split('.');
    let result = obj;

    for (const k of keys) {
        // 如果属性名包含 [ ]，解析数组索引
        if (/\[\d+\]/.test(k)) {
            const [propName, index] = k.split('[');
            const idx = parseInt(index.slice(0, -1)); // 去掉末尾的 ']'
            if (result[propName] && Array.isArray(result[propName])) {
                result = result[propName][idx];
            } else {
                return undefined; // 或者抛出错误，根据需要处理
            }
        } else {
            // 否则，直接访问属性
            if (result[k]) {
                result = result[k];
            } else {
                return undefined; // 或者抛出错误，根据需要处理
            }
        }
    }

    return result;
}

//将订单列表中的多个商品拆分为多个订单。
export function orderGoodsSplice(array) {
    try {
        if (is_Empty(array)) return [];
        let arr = array.concat([]);
        let tempList = [];
        for (let i = 0; i < arr.length; i++) {
            let order = Object.assign({}, arr[i]);

            //如果当前订单列表上并没有返回订单商品信息，则直接向订单列表中push数据。
            if (is_Empty(order.orderGoodsBeans)) tempList.push(order);
            for (let j = 0; j < order.orderGoodsBeans.length; j++) {
                let e = order.orderGoodsBeans[j];
                // 因为商品名称需要展示为俗称+标准名称,所以将商品俗称中的英文去掉,以便于拼接
                e.goods_nonstandard_name = strNames(e.goods_nonstandard_name);
                // 有些遗留订单没有俗称,那就用商品名称替代
                if (is_Empty(e.goods_nonstandard_name)) {
                    e.goods_nonstandard_name = e.goods_name;
                }
                e.goods_name = `${e.goods_name} ${e.goods_standard_name}`
                let good = Object.assign({}, order);
                e.spec_name = specNameInit(e)
                good.orderGoodsBeans = [e];
                good.goods_total_length = order.orderGoodsBeans.length;
                good.goods_index = j;
                tempList.push(good);
            }
        }
        return tempList;
    } catch (e) {
        console.log(e);
        return [];
    }

}

//权限-ID
export function hasPermission(role) {
    if (!role) return true;
    let permission_ids = store.state.permission_ids || [];
    if (Array.isArray(role)) {
        for (let i = 0; i < role.length; i++) {
            let is = permission_ids.indexOf(role[i])
            if (is !== -1) {
                return false;
            }
        }
        return true;
    }
    return permission_ids.indexOf(role) === -1;
}

//权限-角色
export function hasRole(role_id) {
    if (is_Empty(role_id)) return false;
    let role_ids = is_Empty(store.state.memberInfo.role_ids) ? [] : store.state.memberInfo.role_ids;
    if (Array.isArray(role_id)) {
        for (let i = 0; i < role_id.length; i++) {
            if (role_ids.indexOf(role_id[i]) === -1) {
                return false;
            }
        }
        return true;
    }
    return role_ids.indexOf(role_id) === -1;
}

//判断是否为空
export function is_Empty(targe) {
    if (targe === null) {
        return true;
    }
    if (targe === undefined) {
        return true;
    }
    if (typeof targe == 'number')
        return false;
    if (typeof targe == 'string') {
        if (targe == '') {
            return true;
        } else {
            return false;
        }
    }
    if (typeof targe == 'object') {
        for (let i in targe) {
            return false;
        }
        return true;
    }
    return false;

}

//计算分数
export function scoreLevel(score) {
    let obj = {
        level_img: "high",
        level_name: "高风险"
    }
    if (is_Empty(score)) return obj;
    switch (Math.floor(score / 10)) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            obj.level_name = "高风险";
            obj.level_img = "high";
            break;
        case 6:
        case 7:
            obj.level_name = "中风险";
            obj.level_img = "in";
            break;
        case 8:
        case 9:
        case 10:
            obj.level_name = "低风险";
            obj.level_img = "low";
            break;
        default:
            obj.level_name = "未评估";
            obj.level_img = "unscored";
            break;
    }
    return obj;
}
/**
 * 让浏览器全屏切换
 * @returns {boolean} 是否是全屏状态
 */
export function toggleFullscreen(el, fullscreen) {
    if (!el) {
        el = document.documentElement;
        if (fullscreen === undefined) {
            fullscreen = !(
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement
            );
        }
    }
    if (fullscreen) {
        const rfs = (
            el.requestFullScreen ||
            el.webkitRequestFullScreen ||
            el.mozRequestFullScreen ||
            el.msRequestFullScreen
        );
        if (rfs) {
            rfs.call(el);
        } else {
            throw new Error('您的浏览器不支持全屏模式');
        }
    } else {
        const cfs = (
            document.exitFullScreen ||
            document.webkitCancelFullScreen ||
            document.mozCancelFullScreen ||
            document.msExitFullscreen
        );
        if (cfs) {
            cfs.call(document);
        }
    }
    return fullscreen;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js